import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Typography} from '@material-ui/core';
import NavBar from '../components/navbar';
import start from '../assets/start.png';
import vision from '../assets/vision.png';
import LyraIcon from '../assets/LyraIcon.png'; 


const useStyles = makeStyles((theme) => ({
    
title:{
fontFamily:['Nunito'].join(','),
fontSize:'26px',
fontWeight:900,
color:'#153BAB',
paddingTop:'20px',
paddingBottom:'20px',

},
titleAbout:{
    fontFamily:['Nunito'].join(','),
    fontSize:'26px',
    fontWeight:900,
    color:'#153BAB',
    marginTop:'80px',
    paddingBottom:'20px',

},
info:{
    fontFamily:['Nunito'].join(','),
    fontSize:'18px',
    fontWeight:400,
    color:'#4F5052',
    paddingTop:'5px',
    paddingBottom:'5px',
    maxWidth:'75%'
},
foot:{
     padding: '100px 100px 50px 100px',
},
ContainerOne:{
    padding: '180px 100px 120px 100px',
    maxWidth:'60%',
    backgroundImage: `url(${LyraIcon})`,
    backgroundRepeat:'no-repeat',
    backgroundSize:'180px 570px'
},
ContainerTwo:{
    padding: '80px 100px 80px 100px',
    backgroundColor: 'rgba(168, 219, 239, 0.2)',

},
ContainerThree:{
    padding: '80px 100px 80px 100px',
},
cols:{
    display:'flex',
    flexDirection:'column',
},
rows:{
    display:'flex',
    flexDirection:'row',
},
image:{
    marginTop:'90px',
    width:'325px',
    height:'325px'
},
imageVision:{
    marginTop:'30px',
    width:'325px',
    height:'325px'
},
infoVision:{
    fontFamily:['Nunito'].join(','),
    fontSize:'18px',
    fontWeight:400,
    color:'#4F5052',
    paddingTop:'5px',
    paddingBottom:'70px',
    maxWidth:'75%'

}
}));

export default function GitHubLink(props) {
  const classes = useStyles();
    return(
    <div>
        <NavBar type='main'/>
        <div className={classes.content}>

            <div className={classes.ContainerOne}>
            <Typography className={classes.titleAbout}>About Lyra </Typography>
            <Typography className={classes.info}>Lyra is a pioneer of AI talent sourcing. 
            We take pride in our diverse network of world-class AI & Data Science talent.
             With a seamless recruitment process built on quality & speed, Lyra can help you grow your AI team within
              the shortest time in the market.
            </Typography>
            </div>

            <div className={classes.ContainerTwo}>
                <div className={classes.rows}>
                    <div className={classes.cols}>
                    <Typography className={classes.title}>How We Started</Typography>
                    <Typography className={classes.info}>After encountering our own challenges to hire data scientists
                        & AI engineers, we quickly realized that accessing qualified talent is a universal pain point.
                        We also realized that the MEA (Middle East & Africa)
                        is an underrepresented and inaccessible tech hub. </Typography>
                        <Typography className={classes.info}>
                        And so, the idea behind Lyra originated. We built a network of
                        top-notch AI talent in the MEA and started our journey.
                    </Typography>
                    <Typography className={classes.info}>
                    Lyra connects businesses around the world with vetted AI & Data Science talent.
                        We take pride in our recruitment process that is seamless, reliable, and faster than conventional methods.
                    </Typography>
                    </div>
                    <div className={classes.cols}>
                    <img className={classes.image} src={start} alt="iamge"/>
                    </div>
                </div>
                
            </div>

            <div className={classes.ContainerThree}>
                <div className={classes.rows}>
                    <div className={classes.cols}>
                    <Typography className={classes.title}>Lyra’s Vision</Typography>
                        <Typography className={classes.infoVision}>Lyra aspires to be the world’s hub of top-notch AI &
                        Data Science talent, connecting thousands of companies around
                        the world with vetted talent faster & better than any other channel. </Typography>
                        <Typography className={classes.title}>Our Mission</Typography>
                        <Typography className={classes.info}>
                        Our mission is to empower AI engineers and data scientists to solve the world’s biggest challenges
                        & connect employers with vetted talent seamlessly, quickly, and reliably.
                        </Typography>
                    </div>  
                    <div className={classes.cols}>
                    <img className={classes.imageVision} src={vision} alt="iamge"/>
                    </div>
                </div>
            </div>


        </div>

        <div className={classes.foot}>
        {/* <Footer /> */}
        </div>
        
    </div>  
    );
}
